import './SpendLevel.sass';

import React, { FC } from 'react';

import { SpendLevelProps } from './SpendLevel.interface';

export const SpendLevel: FC<SpendLevelProps> = ({ level = 0 }) => {
  switch (level) {
    case 1: {
      return <div className="SpendLevel SpendLevel__low">$</div>;
    }
    case 2: {
      return <div className="SpendLevel SpendLevel__medium">$$</div>;
    }
    case 3: {
      return <div className="SpendLevel SpendLevel__high">$$$</div>;
    }
    default: {
      return null;
    }
  }
};
